import { gql } from '@apollo/client';

export const fetchListsWithParamsQuery = gql`
  fragment listsPageInfo on Lists {
    info {
      limit
      offset
      count
    }
  }
  query fetchLists($filterInfo: ListFilterInfoInput, $pagination: Pagination) {
    lists(filterInfo: $filterInfo, pagination: $pagination) {
      ...listsPageInfo
      results {
        id
        name
      }
    }
  }
`;
